module.exports = __webpack_public_path__ + "static/media/ico-check-green-001.020c5db0.svg";